import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';
import img from './photos/him-chatterjee.jpg';

function Navbar() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ✅ Fetch categories + subcategories from backend
    useEffect(() => {
        fetch("https://himchatterjee.in/backend/getCategories.php")
            .then(res => res.json())
            .then(data => setCategories(data))
            .catch(err => console.error("Error fetching categories:", err));
    }, []);

    const show_nav = () => {
        document.getElementById("navs").classList.toggle("cng_nav");
        document.getElementById("cross").classList.toggle("fa-x");
        document.getElementById("ot_tp").classList.toggle("color_cng");
    };

    const removeNav = () => {
        document.getElementById("navs").classList.remove("cng_nav");
        document.getElementById("cross").classList.remove("fa-x");

        // सभी dropdown बंद करो
        document.querySelectorAll(".nav-item").forEach(item => {
            item.classList.remove("dropdown-active");
        });
    };

    const toggleDropdown = (e) => {
        if (isMobile) {
            e.preventDefault();

            // सभी dropdown को बंद करो
            document.querySelectorAll(".nav-item").forEach(item => {
                if (item !== e.currentTarget.parentElement) {
                    item.classList.remove("dropdown-active");
                }
            });

            // current item toggle करो
            e.currentTarget.parentElement.classList.toggle("dropdown-active");
        }
    };

    let navigate = useNavigate();

    // useEffect(() => {
    //     let localData = localStorage.user;
    //     if (localData) {
    //         navigate("/");
    //     }
    // }, [navigate]);

    return (
        <>
            {/* Mobile Top Navbar */}
            <div className="p_nav">
                <div className="outer_topi" id='ot_tp'>
                    <img src={img} className="round-img" width='50px' height='40px' alt="profile" />
                    <NavLink to="/" className="logo" style={{ textDecoration: 'none', color: 'inherit' }}>
                        HIM CHATTERJEE
                    </NavLink>
                </div>
                <div className="inner111">
                    <div className="social-icons">
                        <a href="https://in.linkedin.com/in/him-chatterjee-a6545722" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                        <a href="https://in.pinterest.com/himchatterjee9/" target="_blank" rel="noopener noreferrer"><i className="fab fa-pinterest"></i></a>
                        <a href="https://www.facebook.com/him.chatterjee.9" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                    </div>
                    <div onClick={show_nav} id='btn'><i id='cross' className="fa-solid fa-bars"></i></div>
                </div>
            </div>

            {/* Desktop Top Navbar */}
            <nav>

                <div className="icon">
                    <img src={img} className="round-img" width='50px' height='40px' alt="profile" />
                    <NavLink to="/" className="logo" style={{ textDecoration: 'none', color: 'inherit' }}>
                        HIM CHATTERJEE
                        <span style={{ fontSize: '0.9rem', fontWeight: 'normal' }}> Visual Artist</span>
                    </NavLink>
                </div>

                <div className="nav-right">
                    <div className="search-box">
                        <button className="search-btn"><i className="fas fa-search"></i></button>
                        <input type="text" className="search-input" placeholder="Search art or artist" />
                    </div>
                    <div className="social-icons">
                        <a href="https://in.linkedin.com/in/him-chatterjee-a6545722" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                        <a href="https://in.pinterest.com/himchatterjee9/" target="_blank" rel="noopener noreferrer"><i className="fab fa-pinterest"></i></a>
                        <a href="https://www.facebook.com/him.chatterjee.9" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                    </div>
                </div>
            </nav>

            {/* Main Navigation */}
            <nav id='navs'>
                <ul className="nav-list">
                    {categories.map(cat => (
                        <li key={cat.id} className="nav-item">
                            <NavLink
                                onClick={isMobile ? toggleDropdown : removeNav}
                                to={`/${cat.name.toLowerCase().replace(/\s+/g, '-')}`}
                            >
                                {cat.name} {cat.subcategories.length > 0 && (isMobile && <span className="arrow">&#9662;</span>)}
                            </NavLink>
                            {cat.subcategories.length > 0 && (
                                <div className="dropdown-menu">
                                    {cat.subcategories.map(sub => (
                                        <NavLink
                                            key={sub.id}
                                            onClick={removeNav}
                                            to={`/${cat.id}/${sub.id}`}
                                        >
                                            {sub.name}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </li>
                    ))}

                    {/* Manually added About menu */}
                    <li className="nav-item">
                        <NavLink
                            onClick={isMobile ? toggleDropdown : removeNav}
                            to="/about"
                        >
                            About {isMobile && <span className="arrow">&#9662;</span>}
                        </NavLink>
                        <div className="dropdown-menu">
                            <NavLink onClick={removeNav} to="/about/intro">Him Chatterjee</NavLink>
                            <NavLink onClick={removeNav} to="/about/exhibitions">Exhibitions</NavLink>
                            <NavLink onClick={removeNav} to="/about/achievements">Biography</NavLink>
                            <NavLink onClick={removeNav} to="/about/teaching">Teaching</NavLink>
                        </div>
                    </li>


                    {/* 🔹 Manually added Contact Us menu */}
                    <li className="nav-item">
                        <NavLink
                            onClick={removeNav}
                            to="/contact"
                        >
                            Contact Us
                        </NavLink>
                    </li>
                </ul>
            </nav>

        </>
    );
}

export default Navbar;
